// extracted by mini-css-extract-plugin
export default {"tableTitle":"financials_tableTitle__1S+hw","bankBalanceHeader":"financials_bankBalanceHeader__Yc5L0"};